var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Header',{attrs:{"username":_vm.username}}),_c('Nav',{attrs:{"user_level":_vm.user_level,"menuItems":_vm.menuItems}}),_c('router-view',{on:{"logged":function($event){_vm.n += 1}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }